import cx from 'classnames';
import { FormGroup, Input, Text } from 'tombac';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export default function SquareKmLimitEditor({
  className,
  defaultLimit = null,
  label,
  limit = null,
  onChange,
  schema
}) {
  const handleChange = event => {
    if (event.target.value.trim() === '') onChange(null);else {
      const newLimit = Number(event.target.value);
      if (Number.isNaN(newLimit)) onChange(limit);else onChange(Math.abs(Math.floor(newLimit)));
    }
  };
  const placeholder = defaultLimit !== null ? String(defaultLimit) : 'Unlimited';
  return /*#__PURE__*/_jsx(FormGroup, {
    $width: "100%",
    className: cx('SquareKmLimitEditor', className),
    htmlFor: `input-${schema.name}`,
    label: label,
    "data-sentry-element": "FormGroup",
    "data-sentry-component": "SquareKmLimitEditor",
    "data-sentry-source-file": "SquareKmLimitEditor.tsx",
    children: schema.customizable ? /*#__PURE__*/_jsx(Input, {
      $flex: "auto",
      append: /*#__PURE__*/_jsxs(Text, {
        $mt: "0.2em",
        as: "span",
        children: ["km", /*#__PURE__*/_jsx("sup", {
          children: "2"
        })]
      }),
      id: `input-${schema.name}`,
      onChange: handleChange,
      placeholder: placeholder,
      type: "text",
      value: limit === null ? '' : limit.toString()
    }) : /*#__PURE__*/_jsx("div", {
      className: "LimitEditor__value",
      children: limit !== null ? /*#__PURE__*/_jsxs(_Fragment, {
        children: [limit, " km", /*#__PURE__*/_jsx("sup", {
          children: "2"
        })]
      }) : placeholder
    })
  });
}